export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8824.676e7dbb.jpg";